module.exports = __webpack_public_path__ + "img/handshake-avatar.ff1c9962.jpeg";